import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';  
//page links  
import Header from '../master_root/header';
import PhoneCodeList from '../components/PhoneCodeList';
import './create-job-profile.css';
import { BsPersonWorkspace } from "react-icons/bs";
export default function Createjobprofile() {
  const [loading, setLoading] = useState(false);
  //

//
  const [keywords, setKeywords] = useState([]);
  const [input, setInput] = useState('');
  const [Companyinput, setCompanyinput] = useState('');
  const [Websiteinput, setWebsiteinput] = useState('');
  const [Descriptioninput, setDescriptioninput] = useState('');
  const [Addressinput, setAddressinput] = useState('');
  const [Cityinput, setCityinput] = useState('');
  const [Stateinput, setStateinput] = useState('');
  const [PostalCodeinput, setPostalCodeinput] = useState('');
//
  const [PhoneCodes, setPhoneCodes] = useState(null); 
  const [countryname, setSelectedcountryname] = useState(null);  
  const PhoneCodeListhandleChange = (selectedOption) => {
    setPhoneCodes(selectedOption.value);
    const countryName = selectedOption.label.split(" (")[0]; 
    setSelectedcountryname(countryName);
   // console.log("Selected Code:", selectedOption.value); 
    //document.querySelector('.phone-input').focus(); 
};

  const create_job_profile = async (e) => {
    e.preventDefault();
  }
  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && input.trim() !== '' && keywords.length < 10) {
      e.preventDefault();
      const trimmed = input.trim();
      if (!keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setInput('');
    }
    if (e.key === ',' && input.trim() !== '' && keywords.length < 10) {
      e.preventDefault();
      const trimmed = input.trim();
      if (!keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setInput('');
    }
  };
  function generateSlug(websiteName) {
    try {
      // Ensure the website name is a valid URL (if it doesn't start with 'http' or 'https', add 'https://')
      const url = new URL(websiteName.startsWith('http') ? websiteName : 'https://' + websiteName);
      
      // Extract the hostname (i.e., the domain part)
      let parts = url.hostname.split('.');
  
      // Remove the last part (extension) and the first 'www' part if present
      let mainPart = parts.length > 2 ? parts.slice(0, -1).join('_') : parts[0];
  
      // Remove 'www' if it's the first part
      if (mainPart.startsWith('www')) {
        mainPart = mainPart.slice(4); // Remove 'www' from the start
      }
  
      // Replace '.' with '_' and return the cleaned-up domain name
      return mainPart.toLowerCase().replace(/\./g, '_');
    } catch (e) {
      console.warn("Invalid website name:", websiteName);
      return '';
    }
  }
  
  return (
      <div >
               <Header /> 
                    <div className='app_header_height'></div>
    <div className="container_roots">
  
  <Helmet>
  <title>Create Job Profile - EditorTask | Showcase Your Talent & Get Hired</title>

  <meta name="description" content="Create your job profile on EditorTask to showcase your creative talent, portfolio, and skills. Connect with clients and get hired for freelance projects." />
  <meta name="keywords" content="create job profile, freelance talent, editor portfolio, hire creative professionals, video editors, designers, India freelance jobs, EditorTask profile" />
  <meta name="author" content="editortask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Create Job Profile - EditorTask | Showcase Your Talent & Get Hired" />
  <meta property="og:description" content="Build your job profile to get noticed. Join EditorTask and start your freelance journey by showcasing your best work and skills." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/create-job-profile" />
  <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
</Helmet>
<div className="container_size"> 
        <div className='post-container'>      
          <div className='post_div'>
            <div className='title-div'>
              <div className='header-text'>Create Job Profile</div>
              <div className='sub-header-text'>Fill in the details to Showcase Your Talent & Get Hired</div>
            </div>
            <table className='data-input-body'>
              <tr><td className='lable-text'>
               Name
                </td></tr>
                <tr><td >
             <input className='bold-data-input' 
               onChange={(e) => setCompanyinput(e.target.value)}

             maxLength={60} placeholder='Your full name'></input>
                </td></tr>
                <tr><td className='lable-text'>
                Industry: Add a new entry or use commas (,) to separate multiple
                </td></tr>
                <tr><td >
                <div className="keyword-container">
                        {keywords.map((word, index) => (
                          <div key={index} className="keyword-chip">
                            {word}
                            <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                          </div>
                        ))}
                        <input
                          value={input}
                          onChange={(e) => setInput(e.target.value)}
                          onKeyDown={handleKeyDown}
                          className="select_input_edit"
                          maxLength={100}
                          placeholder="Your Industry"
                        />
                      </div>
                </td></tr>
                <tr><td className='lable-text'>
                Description
                </td></tr>
                <tr><td >
             <textarea className='data-input' maxLength={60}
               onChange={(e) => setDescriptioninput(e.target.value)}
             placeholder='Your Business Description'></textarea>
                </td></tr>
                <tr><td className='lable-text'>
                Website
                </td></tr>
                <tr><td >
             <input className='info-data-input' maxLength={60} 
                  onChange={(e) => setWebsiteinput(e.target.value)}
             placeholder='Your Website'></input>
                </td></tr>
              
                <tr><td className='lable-text'>
                Address
                </td></tr>
                <tr><td >
             <textarea className='data-input' maxLength={160}
                      onChange={(e) => setAddressinput(e.target.value)}
              placeholder='Your Business Address'></textarea>
                </td></tr>
                <tr><td className='lable-text'>
                City / Postal Code
                </td></tr>
                <tr><td >
             <input className='info-data-input' maxLength={60}
               onChange={(e) => setCityinput(e.target.value)}
             placeholder='Your City'></input>
             <input className='info-data-input' maxLength={10} 
               onChange={(e) => setPostalCodeinput(e.target.value)}
             placeholder='Your Postal Code'></input>
                </td></tr>
                <tr><td className='lable-text'>
                State
                </td></tr>
                <tr><td >
                  <div>
             <input className='info-data-input' maxLength={60}
                     onChange={(e) => setStateinput(e.target.value)}
             placeholder='Your State'></input>
             </div>
                </td></tr>
                <tr><td className='lable-text'>
                Country {PhoneCodes}
                </td></tr>
                <tr><td >
                  <div className='Country-data-input'>
                  <PhoneCodeList  
                options={PhoneCodes} 
                placeholder="Select country"
                onChange={PhoneCodeListhandleChange}  
            />
             </div>
                </td></tr>
            </table>
            <br/>
          
            <br/>
           <div className='button-ui' onClick={create_job_profile}><BsPersonWorkspace className='icon' />
           {loading ? <Lodinging /> : "Continue & Verify"}
           </div>
            </div> 
          <div className='post_updates'>
          <div className='post_div' >
          <div className='guide-tipes-div'>
  Use your real name or a professional alias. This helps you build a trustworthy and recognizable identity.
</div>

<div className='guide-tipes-div'>
  <b>Upload a clear profile picture:</b><br/>
  A front-facing, high-quality photo creates a strong first impression. Avoid logos or group pictures.
</div>

<div className='guide-tipes-div'>
  <b>Write a short professional bio:</b><br/>
  Introduce yourself in 2–3 lines. Mention your role, experience, and passion. Example: “Freelance video editor with 3+ years of experience in storytelling and post-production.”
</div>

<div className='guide-tipes-div'>
  <b>Select your skill categories:</b><br/>
  Choose areas like Video Editing, Graphic Design, Content Writing, or others that best represent your strengths.
</div>

<div className='guide-tipes-div'>
  <b>Add your key skills:</b><br/>
  Be specific – for example: Adobe Premiere Pro, After Effects, SEO Writing, WordPress, Illustration, Figma, etc.
</div>

<div className='guide-tipes-div'>
  <b>Upload work samples or showcase projects:</b><br/>
  Add images, video links, or portfolio items. This increases your chances of getting hired by showing proof of work.
</div>

<div className='guide-tipes-div'>
  <b>Set your availability & work type:</b><br/>
  Mention if you’re open to freelance, full-time, part-time, remote, or contract work. It helps job providers reach you correctly.
</div>

<div className='guide-tipes-div'>
  <b>Add your location:</b><br/>
  This helps match you with local jobs and increases profile credibility.
</div>

<div className='guide-tipes-div'>
  <b>Experience & Education (Optional but Recommended):</b><br/>
  Mention past roles, projects, or academic qualifications relevant to your field.
</div>

<div className='guide-tipes-div'>
  <b>Add your social/portfolio links:</b><br/>
  Link your Behance, GitHub, LinkedIn, or personal website to show your extended profile.
</div>

<div className='guide-tipes-div'>
  <b>Pro Tip:</b><br/>
  A complete and well-written job profile gets more visibility and trust. Keep it updated with your latest work.
</div>

           </div>
          </div>  
        </div>
      </div>
      </div>
</div>
    );
}
